import React from 'react';
import { BookOpen, ShoppingCart, Heart, Check } from 'lucide-react';
import { Card } from '../ui/Card';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="h-8 w-8 text-brand-dark" data-id="element-280" />,
    title: 'El Protocolo de 7 Días Paso a Paso',
    desc: 'Sabrás exactamente qué comer desde que despiertas hasta que duermes para ver resultados en el espejo en 48 horas. Sin contar calorías, sin pasar hambre.'
  }, {
    icon: <ShoppingCart className="h-8 w-8 text-brand-dark" data-id="element-281" />,
    title: 'Guía de Compras Express (USA)',
    desc: 'Lista de la compra seleccionada específicamente para Walmart, Target y Costco. Entra y sal en 15 minutos con todo lo que necesitas.'
  }, {
    icon: <Heart className="h-8 w-8 text-brand-dark" data-id="element-282" />,
    title: 'El Ritual del Cortisol',
    desc: 'Una técnica de 5 minutos para detener la acumulación de grasa abdominal por estrés. Ideal para mujeres ocupadas.'
  }, {
    icon: <Check className="h-8 w-8 text-brand-dark" data-id="element-283" />,
    title: "La Lista de 'Venenos Saludables'",
    desc: '3 alimentos que crees que te ayudan pero que están saboteando tu abdomen ahora mismo. Elimínalos y verás la diferencia.'
  }];
  return <section className="py-20 bg-brand-cream" data-id="element-284">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        <div className="text-center mb-16" data-id="element-286">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-287">
            Lo que recibirás hoy
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-288">
            Todo lo que necesitas para resetear tu cuerpo, en un formato digital
            fácil de seguir.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-289">
          <div className="grid gap-6" data-id="element-290">
            {deliverables.map((item, i) => <Card key={i} className="p-6 hover:shadow-lg transition-shadow border-l-4 border-l-brand-gold" data-id="element-291">
                <div className="flex items-start" data-id="element-292">
                  <div className="bg-brand-light p-3 rounded-lg mr-4" data-id="element-293">
                    {item.icon}
                  </div>
                  <div data-id="element-294">
                    <h3 className="text-xl font-bold text-brand-dark mb-2 font-serif" data-id="element-295">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-296">{item.desc}</p>
                  </div>
                </div>
              </Card>)}
          </div>

          <div className="relative flex justify-center" data-id="element-297">
            <div className="absolute inset-0 bg-brand-gold/20 rounded-full blur-3xl transform scale-90" data-id="element-298"></div>
            <img src="https://cdn.magicpatterns.com/uploads/kf3Aijir3bQeSCoh52kfNb/heylloyd-image-1771657867840.png" alt="Reset Metabólico Materiales" className="relative z-10 w-full max-w-md drop-shadow-2xl transform hover:-translate-y-2 transition-transform duration-500" data-id="element-299" />
          </div>
        </div>
      </div>
    </section>;
}